import { render } from "./pedidos.vue?vue&type=template&id=2cefc7ef"
import script from "./pedidos.vue?vue&type=script&lang=js"
export * from "./pedidos.vue?vue&type=script&lang=js"

import "./pedidos.vue?vue&type=style&index=0&id=2cefc7ef&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__